import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getHotelDetails } from '../services/apiservice';

const HotelContext = createContext({});
export const useHotel = () => useContext(HotelContext);

function HotelContextProvider(props) {
    const [hotelDetails, setHotelDetails] = useState({});
    const [serviceList, setServiceList] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const isMobileView = window.innerWidth <= 769 && window.innerHeight <= 1000;
    useEffect(() => {
        let hotelID;
        let urlHotelID = '';
        let urlRoomNumber = '';

        if (location.pathname.includes('welcome')) {
            let splitedLocation = location.pathname.split('/');
            if (
                splitedLocation.includes('welcome') &&
                splitedLocation.length >= 3
            ) {
                urlHotelID = splitedLocation[2];
                urlRoomNumber = splitedLocation[3] || '';
            }
            if (splitedLocation.length === 3) {
                if (
                    splitedLocation[1] === 'welcome' &&
                    splitedLocation[2].length > 10
                ) {
                    localStorage.setItem('hotel_id', splitedLocation[2]);
                    navigate('/splash-screen', { replace: true });
                }
            }
        }
        const existingHotelID = localStorage.getItem('hotel_id');
        const existingRoomNumber = localStorage.getItem('room_no');

        if (urlHotelID) {
            if (
                urlHotelID !== existingHotelID ||
                urlRoomNumber !== existingRoomNumber
            ) {
                localStorage.clear();
                localStorage.setItem('hotel_id', urlHotelID);
                hotelID = urlHotelID;
            } else {
                hotelID = existingHotelID;
            }
        } else {
            hotelID = existingHotelID;
        }
    }, [location.pathname]);

    useEffect(() => {
        fetchHotelDetails();
    }, []);

    const fetchHotelDetails = async () => {
        try {
            setLoading(true);
            const response = await getHotelDetails();
            if (response?.status === 200) {
                const properties = response.data || {};
                setHotelDetails(properties);

                if (location.pathname.includes('welcome')) {
                    let spiltedPath = location.pathname.split('/');
                    if (
                        spiltedPath.includes('welcome') &&
                        spiltedPath.length >= 3
                    ) {
                        navigate('/splash-screen', { replace: true });
                    }
                }
            }
        } catch (error) {
            const { response, ...errorObj } = error;
            if (response?.status === 401) {
                navigate('/page-not-found', { replace: true });
            }
        } finally {
            setLoading(false);
        }
    };

    const value = {
        hotelDetails,
        loading,
        serviceList,
        isMobileView
    };
    return (
        <HotelContext.Provider value={value}>
            {props.children}
        </HotelContext.Provider>
    );
}

export default HotelContextProvider;
